module.exports = __webpack_public_path__ + "static/media/scalefusion.823330c4.png";